export default () => ({
  link($scope, $element, $attrs) {
    let count = $scope.$eval($attrs.evaResourceCount);
    let tt = $attrs.evaResourceType.split(',');
    $element.text(`${count} ${(count == 1 ? tt[0] : tt[1])}`);
  }
});
